module.exports = __webpack_public_path__ + "img/gp_promotion_male_3.56b8d2b8.png";